import axios, { apiBaseURL } from '../axios'

const skillsBaseURL = `${apiBaseURL}/skills`

export default class SkillsApi {
  static getSkills(): Promise<ISkills> {
    return axios.get(skillsBaseURL)
  }
}
